<div class="administration-menu w-[300px]">
  @for (item of administrationMenu; track item) {
    @if (item.userPermissions?.length) {
      <ng-container *vicpCheckUserPermissions="item.userPermissions!; mode: 'hide';">
        <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: item }"></ng-container>
      </ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: item }"></ng-container>
    }
  }
</div>

<ng-template #menuItemTemplate let-item>
  <a
    data-e2e="administrationMenuElements"
    class="menu-item flex h-[68px] w-full cursor-pointer px-[15px]"
    [routerLink]="item.link"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: false }"
    (click)="routerLinkActivated.emit()"
  >
    <div class="flex h-full w-full items-center">
      <span class="text-base font-semibold">{{ item.label | translate }}</span>
    </div>
  </a>
</ng-template>
